import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatTime(date) {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatDuration(seconds) {
  if (!seconds) return '0:00';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function calculateWinRate(wins, total) {
  if (!total || total === 0) return 0;
  return Math.round((wins / total) * 100);
}

export function getSkillLevelColor(level) {
  const colors = {
    beginner: 'bg-green-500',
    intermediate: 'bg-blue-500',
    advanced: 'bg-purple-500',
    professional: 'bg-red-500',
  };
  return colors[level] || 'bg-gray-500';
}

export function getStatusColor(status) {
  const colors = {
    scheduled: 'bg-blue-500',
    live: 'bg-red-500',
    completed: 'bg-green-500',
    cancelled: 'bg-gray-500',
  };
  return colors[status] || 'bg-gray-500';
}

export function getRankBadge(rank) {
  if (rank === 1) return { class: 'rank-gold', icon: '🥇' };
  if (rank === 2) return { class: 'rank-silver', icon: '🥈' };
  if (rank === 3) return { class: 'rank-bronze', icon: '🥉' };
  return { class: 'bg-slate-600 text-white', icon: rank };
}
